import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProviderComponent } from './provider/provider.component';
import { ProvidersComponent } from './providers.component';


const routes: Routes = [
  {
    path: "", component: ProvidersComponent ,children:[
      { path: "Providers", component: ProviderComponent},
      { path: "", redirectTo: 'Providers', pathMatch: 'full'},

 
 ]}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
exports: [RouterModule]
})
export class ProvidersRoutingModule { }
